import React, { useState } from "react";
import { FaIcon } from "lib/FaIcon";
import { Alert, Collapse, Button } from "react-bootstrap";
import { NoInternetMsg } from "../pages/login/LogIn";

export const ErrorMsg = (error) => {
  const [open, setOpen] = useState(false);
  if (!navigator.onLine) return <NoInternetMsg />;

  return (
    <Alert variant="danger" onClick={() => setOpen(!open)}>
      <FaIcon icon="fa fa-exclamation-circle fa-lg mr-1" />
      Sorry, the service cannot currently serve this request, please try again later.
      <Collapse in={open}>{AdvancedInfo({ error })}</Collapse>
    </Alert>
  );
};

export const AdvancedInfo = ({ error }) => (
  <section>
    <br />
    Advanced Information:
    <pre>{JSON.stringify(error, null, 3)}</pre>
    <a
      href={`mailto:toolkit-eu@nomura.com?subject=GRP Error log&body=${encodeURIComponent(
        JSON.stringify(error, null, 3)
      )}`}
    >
      <Button size="sm">
        <FaIcon icon="fa fa-envelope fa-lg mr-1" />
        Report Error
      </Button>
    </a>
  </section>
);
